import React, { FC } from "react";
import PostCardCommentBtn from "components/PostCardCommentBtn/PostCardCommentBtn";
import PostCardLikeAction from "components/PostCardLikeAction/PostCardLikeAction";

export interface Subject {
  id: string;
  href: string;
  commentsAmount: number;
  likesAmount: number;
}

export interface PostCardLikeAndCommentProps {
  className?: string;
  itemClass?: string;
  hiddenCommentOnMobile?: boolean;
  useOnSinglePage?: boolean;
  data?: Subject;
}

const PostCardLikeAndComment: FC<PostCardLikeAndCommentProps> = ({
  className = "",
  itemClass = "px-3 h-8 text-xs",
  hiddenCommentOnMobile = true,
  useOnSinglePage = false,
  data,
}) => {
  if (data !== undefined && data.likesAmount <= 0 && data.commentsAmount <= 0) return null;

  return (
    <div
      className={`nc-PostCardLikeAndComment flex items-center space-x-2 ${className}`}
    >
      <PostCardLikeAction className={itemClass} likeCount={data?.likesAmount || 0} />
      <PostCardCommentBtn
        className={`${
          hiddenCommentOnMobile ? "hidden sm:flex" : "flex"
        }  ${itemClass}`}
        isATagOnSingle={useOnSinglePage}
        href={data?.href || "/"}
        commentsAmount={data?.commentsAmount || 0}
      />
    </div>
  );
};

export default PostCardLikeAndComment;
